<div [ngClass]="statusClass(equipment)"
     class="status">
  <app-status-history [equipment]="equipment">{{ equipment.status | readable }}</app-status-history>
</div>
